import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { FormattedMessage } from '@dragonraider5/react-intl'
import { Link } from 'react-router-dom'

import { selectCurrentApplication } from '../Applications/selectors'
import { getApplyToStepPath } from '../MainRoutes/utils'
import { stepStatuses } from '../Applications/constants'

import {
  REGISTER_PATH,
  APPLY_PROJECT_PATH,
  APPLY_ORGANIZATION_PATH,
  APPLY_DOCUMMENTS_PATH
} from '../MainRoutes/constants'
import Stepper from '../../components/Stepper'
import RouteStep from './RouteStep'
import messages from './messages'

const mapStateToProps = createStructuredSelector({
  application: selectCurrentApplication
})

const connector = connect(mapStateToProps)

export function MainStepper({
  application
}) {
  return (
    <Stepper>
      <RouteStep path={REGISTER_PATH} disabled>
        <FormattedMessage {...messages.register} />
      </RouteStep>
      <RouteStep
        path={APPLY_PROJECT_PATH}
        as={Link}
        to={application && getApplyToStepPath(stepStatuses.SOLICITUDE, application)}
        disabled={!application || stepStatuses.SOLICITUDE > application.status}
      >
        <FormattedMessage {...messages.project} />
      </RouteStep>
      <RouteStep
        path={APPLY_ORGANIZATION_PATH}
        as={Link}
        to={application && getApplyToStepPath(stepStatuses.DATA, application)}
        disabled={!application || stepStatuses.DATA > application.status}
      >
        <FormattedMessage {...messages.organization} />
      </RouteStep>
      <RouteStep
        path={APPLY_DOCUMMENTS_PATH}
        as={Link}
        to={application && getApplyToStepPath(stepStatuses.DOCUMENTS, application)}
        disabled={!application || stepStatuses.DOCUMENTS > application.status}
      >
        <FormattedMessage {...messages.documments} />
      </RouteStep>
    </Stepper>
  )
}

export default connector(MainStepper)
